export default __webpack_public_path__ + "static/media/institutePlus.618819e6.svg";